import { UserNotification } from '../../../common/validations'
import { ResidentNotificationCategory } from '../../../common/types'

/**
 * Categories `ResidentNotification` renders. Its switch is exhaustive over
 * this list, so adding a category here without rendering it fails the build.
 */
export const shownCategories = [
  ResidentNotificationCategory.arrear,
  ResidentNotificationCategory.contract_termination_request_approval_needed,
  ResidentNotificationCategory.contract_termination_request_tenant_rejected,
  ResidentNotificationCategory.contract_termination_request_kenno_rejected,
  ResidentNotificationCategory.contract_modification_request_approval_needed,
  ResidentNotificationCategory.message,
] as const

export type ShownCategory = (typeof shownCategories)[number]

const isShownCategory = (
  category: ResidentNotificationCategory
): category is ShownCategory =>
  (shownCategories as readonly ResidentNotificationCategory[]).includes(
    category
  )

/** Whether `ResidentNotification` renders anything for the notification */
export const isNotificationShown = (
  notification: UserNotification,
  messaging: boolean
) =>
  isShownCategory(notification.category) &&
  (notification.category !== ResidentNotificationCategory.message || messaging)
